import React from 'react';
import ReactDOM from 'react-dom/client';
import { HeadProvider } from 'react-head'; // ✅ replace HelmetProvider
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HeadProvider>
      <App />
    </HeadProvider>
  </React.StrictMode>
);

serviceWorker.unregister();
